import React, { useEffect } from "react";
import "./Error.css";
import { redicrectAuth } from "../../api";

const ErrorView = ({ error }) => {
  if (redicrectAuth()) {
    window.location.href = "/";
  }

  const clear = () => {
    localStorage.clear();
    window.location.href = "/menu";
  };
  return (
    <div className="error-view">
      <img className="large-svg" src={"red_logo.svg"} />

      <div className="development-text">
        <p>Ooops, something went wrong :( </p>
      </div>
      <div className="error-text">
        <p>{error}</p>
      </div>
      <button className="confirm-button" onClick={clear}>
        Back
      </button>
    </div>
  );
};

export default ErrorView;
